import { FC, ReactNode } from 'react';
import DashboardCard from './DashboardCard';
import DashboardOverlay from './DashboardOverlay';

interface IDashboardProps {
	children: ReactNode;
}

const Dashboard: FC<IDashboardProps> = (props) => {
	return (
		<>
			{/* Transparent layer behind the dashboard to prevent map interactions */}
			<DashboardOverlay />
			
			<DashboardCard>{props.children}</DashboardCard>
		</>
	);
};

export default Dashboard;
